export default "__VITE_ASSET__DtTc0DSL__"